import { render, staticRenderFns } from "./modalOrdenar.vue?vue&type=template&id=09c5fbc1"
import script from "./modalOrdenar.vue?vue&type=script&lang=js"
export * from "./modalOrdenar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports